import { ChangeDetectionStrategy, Component, computed, input, output } from '@angular/core';
import { CurrencyPipe, SlicePipe } from '@angular/common';
import { TranslocoDirective } from '@jsverse/transloco';
import { MatIconModule } from '@angular/material/icon';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { FinancialAccount } from '@ld.consumer-portal/models';
import { BaseModalComponent } from '../base-modal/base-modal/base-modal.component';

@Component({
  selector: 'ld-asset-summary-modal',
  imports: [BaseModalComponent, CurrencyPipe, SlicePipe, TranslocoDirective, MatIconModule, MatProgressSpinnerModule],
  templateUrl: './asset-summary-modal.component.html',
  styleUrl: './asset-summary-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AssetSummaryModalComponent {
  readonly linkedAccounts = input.required<FinancialAccount[]>();

  readonly bankName = input<string>('Your Bank');

  readonly bankLogo = input<string | null>(null);

  readonly isLoading = input<boolean>(false);

  readonly addMore = output<void>();

  readonly done = output<void>();

  readonly cancel = output<void>();

  protected readonly totalBalance = computed(() => {
    return this.linkedAccounts().reduce((sum, a) => sum + (a.balance || 0), 0);
  });

  protected onAddMore(): void {
    if (!this.isLoading()) {
      this.addMore.emit();
    }
  }

  protected onDone(): void {
    if (!this.isLoading()) {
      this.done.emit();
    }
  }

  protected onCancel(): void {
    if (!this.isLoading()) {
      this.cancel.emit();
    }
  }

  protected onBackdropClick(event: MouseEvent): void {
    if (event.target === event.currentTarget && !this.isLoading()) {
      this.cancel.emit();
    }
  }
}
